import React, { use, useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { emailRegex } from '../../../utils/constants';
import PillLabel from '../../pill-label/PillLabel';
import { loadingWrapper } from '../../../utils/loadingWrapper';
import CustomSwitch from '../../custom-switch/CustomSwitch';
import { setShowCreateUserModal } from '../../../slice/showModalSlice';
import useTag from '../../../hooks/useTag';
import useUser from '../../../hooks/useUser';
import { toast } from 'react-toastify';

const CreateUser = ({onSuccess}) => {

    const [userData, setUserData] = useState(
        {
            username: "",
            firstname: "",
            lastname: "",
            email: "",
            userTagIds: [],
            userTagIdsWithTime: [],
            companyName: "",
            enableDoor:false,
            role:""
        }
    );

    const [userTagList, setUserTagList] = useState([]);

    const [companyList, setCompanyList] = useState([
        { id: 1, name: "Nordcom" },
        { id: 2, name: "FNMA" },
    ]);

    const dispatch = useDispatch();
    const {getUserTags,tagLoading} = useTag();
    const { createUser, getRoles, userLoading } = useUser();
    const show = useSelector((state)=> state.showModal.showCreateUserModal);
    const roleList = useSelector((state)=> state.generalSetting.roleList);
    const loading = false;// usare il loading dell'hook in futuro

     const inputValidator = {
            firstname:userData.firstname !== "" && userData.firstname.length > 0,
            lastname:userData.lastname !== "" && userData.lastname.length > 0,
            companyName:userData.companyName !== "",
            email:emailRegex.test(userData.email),
            role: userData.role !== "" || !userData.enableDoor,
        }

    const userDataCheck = () => {
        return !(inputValidator.firstname 
            && inputValidator.lastname 
            && inputValidator.email
            && inputValidator.companyName
            && inputValidator.role
        );
    }


    useEffect(()=>{
        getTags(false);
    },[])

    const getTags = (includeUserTags) => {
        getUserTags(
            (data)=>{
                setUserTagList(data?.content || []);
            },
            (error)=>{
                console.log("errore nel ricevere i tag utente",error)
            },
            includeUserTags
        );
    }


    const closeCreate = () => {
        setUserData({
            username: "",
            firstname: "",
            lastname: "",
            email: "",
            userTagIds: [],
            userTagIdsWithTime: [],
            companyName: "",
            enableDoor:false,
            role:""
        });
        setUserTagList([]);
        dispatch(setShowCreateUserModal());

    };

    const addTagToUser = (tagId) => {
        if(tagId === "") return;
        const id = parseInt(tagId);
        if(userData.userTagIds.includes(id)) return;
        setUserData({...userData, userTagIds:[...userData.userTagIds, id]});
    }

    const removeTagFromUser = (index) => {
        let newTagList = [...userData.userTagIds];
        newTagList.splice(index, 1);
        setUserData({...userData, userTagIds:newTagList});
    }

    //per il change degli input ricordarsi di utilizzare email e username uguali (per comodità)

    const inputHandler = (e) => {
        const { name, value } = e.target;
        if(name === "email"){
            setUserData({ ...userData, [name]: value, username: value });
        }else if(name === "role"){
            if(value === ""){
                setUserData({ ...userData, [name]: value, enableDoor:false });
            }else if(value === "ACCESS_OPERATOR"){
                setUserData({ ...userData, [name]: value, enableDoor:true });
            }else{
                setUserData({ ...userData, [name]: value });
            }
        }else{
            setUserData({ ...userData, [name]: value });
        }
    }

    const toggleDoorHandler = () => {
        if(userData.enableDoor){
            setUserData({...userData, enableDoor:false, role:userData.role === "ACCESS_OPERATOR" ?"":userData.role});
        }else{
            //todo aggiungere il ruolo appena mi comunicano l'enum
            setUserData({...userData, enableDoor:true,role: userData.role === "" ?"ACCESS_OPERATOR":userData.role});
        }
    }

    const sendCreateUser = () =>{
        createUser(
            userData,
            (data)=>{
                toast.success("Utente creato con successo");
                onSuccess();
                closeCreate();
            },
            (error)=>{
                console.log("errore nella creazione dell'utente",error)
            }
        );
    }


  return (
    <Modal show={show} size="md" backdrop={loading?"static":true}  onHide={loading ? null : closeCreate}>
        <Modal.Header closeButton>
            <Modal.Title className='text-primary-custom'>Crea Utente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className='d-flex flex-column gap-3'>
                <fieldset className='detail-fieldset flex-column gap-2 align-items-center w-100'>
                    <legend className="detail-legend text-primary-custom">Dati Anagrafici</legend>
                    <div className='d-flex gap-2'>
                        <div className='d-flex flex-column w-100'>
                            <p className="m-0">Nome</p>
                            <input
                                className={`form-control ${inputValidator.firstname ?"":"is-invalid"}`}
                                type="text"
                                name="firstname"
                                required={true}
                                value={userData.firstname}
                                onChange={inputHandler}
                            ></input>
                        </div>
                        <div className='d-flex flex-column w-100'>
                            <p className="m-0">Cognome</p>
                            <input
                                className={`form-control ${inputValidator.lastname ?"":"is-invalid"}`}
                                type="text"
                                name="lastname"
                                required={true}
                                value={userData.lastname}
                                onChange={inputHandler}
                            ></input>
                        </div>
                    </div>
                    <div className='d-flex w-100'>
                        <div className='d-flex flex-column w-100'>
                            <p className="m-0">Email</p>
                            <input
                                className={`form-control ${inputValidator.email ?"":"is-invalid"}`}
                                type="text"
                                name="email"
                                required={true}
                                value={userData.email}
                                onChange={inputHandler}
                            ></input>
                        </div>
                    </div>
                    <div className='d-flex w-100'>
                        <div className='d-flex flex-column w-100'>
                            <p className="m-0">Compagnia</p>
                            <select
                                className={`form-control ${inputValidator.companyName ?"":"is-invalid"}`}
                                name="companyName"
                                value={userData.companyName}
                                onChange={inputHandler}
                            >
                                <option value={""}>Seleziona una compagnia</option>
                                {
                                    companyList.map((company, index)=>{
                                        return <option key={index} value={company.name}>{company.name}</option>
                                        }
                                    )
                                }
                            </select>
                        </div>
                    </div>
                </fieldset>
                <fieldset className='detail-fieldset flex-column gap-2 align-items-center w-100'>
                    <legend className="detail-legend text-primary-custom">Tag</legend>
                    <div className='d-flex gap-2 w-100 overflow-x-auto pb-4 pt-2'>
                        {
                        userData.userTagIds.length > 0
                        ? userData.userTagIds.map((tagId, index)=>{
                            let tag = userTagList.find((tag)=> tag.id === tagId);
                            if(!tag) return null;
                            return <PillLabel key={index} name={tag.name} color={tag.color} onClick={()=>removeTagFromUser(index)} />
                        })
                        : <p className='text-secondary m-0 text-center w-100'>Nessun tag associato</p>
                        }
                    </div>
                    <div className='d-flex w-100'>
                        <div className='d-flex flex-column w-100'>
                            <select
                                className='form-select'
                                value={""}
                                onChange={(e)=>addTagToUser(e.target.value)}
                            >
                                <option value={""}>Seleziona un tag</option>
                                {
                                userTagList.map((tag, index)=>{
                                    return <option key={index} value={tag.id}>{tag.name}</option>
                                })
                                }
                            </select>
                        </div>
                    </div>
                </fieldset>
                <fieldset className='detail-fieldset flex-column gap-2 align-items-center w-100'>
                    <legend className="detail-legend text-primary-custom">Permessi</legend>
                    <div className='d-flex gap-2 w-100'>
                        <div className='d-flex w-100 gap-4 align-items-center'>
                            <div className='d-flex flex-column justify-content-center'>
                                <p className="m-0">Porte</p>
                                <CustomSwitch id={"roleGuest"} isChecked={userData.enableDoor} onChange={toggleDoorHandler}/>
                            </div>
                            <div className='d-flex flex-column w-100'>
                                <p className="m-0">Autorizzazioni speciali</p>
                                <select
                                    className='form-select'
                                    name="role"
                                    value={userData.role}
                                    onChange={inputHandler}
                                >
                                    <option value={""}>Nessuna Autorizzazione</option>
                                    {
                                        roleList.map((role, index)=>{
                                            return <option key={`role-key-${index}`} value={role.code}>{role.value}</option>
                                            }
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </Modal.Body>
        <Modal.Footer>
            {/* //inserire i bottoni di azione */}
            <div className='d-flex gap-2'>
                <Button variant="secondary" onClick={closeCreate}>Annulla</Button>
                <Button 
                    variant="primary" 
                    className="btn-green"
                    disabled={userDataCheck()|| tagLoading || userLoading}
                    onClick={sendCreateUser}
                >
                    {loadingWrapper(loading,<>Crea Utente</>)}
                </Button>
            </div>
            <div>
                {/* //inserire eventuali messaggi di errore */}
            </div>
            <div>
                {/* //inserire eventuali messaggi di successo */}
            </div>
        </Modal.Footer>
    </Modal>
  )
}

export default CreateUser